// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:45:53

export default {
  "id": "geometry-vibes",
  "slug": "geometry-vibes",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b3507beea8bc46638a6d5e7c768a8202-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b3507beea8bc46638a6d5e7c768a8202/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Geometry Vibes",
      "description": "Geometry Vibes is a reaction-based arcade game where you avoid obstacles, traps and spikes that come at you in waves. Your goal in the game is to keep your arrow on the route and take it as far as possible. The game includes a classic mode with levels, a race mode (2-3-4 players) where you can do multiple races, and an endless mode where you can test yourself! Geometry Vibes, where the excitement never ends, invites you to challenge...\n\n",
      "instructions": "Click to \"MOUSE LEFT-CLICK\" or \"UP ARROW\" and hold to fly up.\nRelease the button to dive down.\nIn 2,3,4 Player game modes, other players are controlled with \"UP ARROW\", \"H\" and \"L\".",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2players",
        "3players",
        "dash",
        "geometry",
        "run"
      ]
    },
    "zh-CN": {
      "title": "几何旋律",
      "description": "几何节奏是一款基于反应的街机游戏，你需要避开一波又一波向你袭来的障碍、陷阱和尖刺。游戏目标是保持你的箭头在路线上，尽可能走得更远。游戏包含经典模式（含关卡）、竞速模式（2-3-4人）以及你可以自我挑战的无尽模式。几何节奏，激情永不落幕，邀请你挑战……",
      "instructions": "点击“鼠标左键”或“上箭头”并按住以向上飞行。\n松开按钮以向下俯冲。\n在2、3、4人游戏模式中，其他玩家使用“上箭头”、“H”和“L”进行控制。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "2人游戏",
        "3人游戏",
        "冲刺",
        "几何",
        "跑"
      ]
    },
    "zh-TW": {
      "title": "幾何動感",
      "description": "幾何波動是一款基於反應的街機遊戲，您需要避開一波又一波的障礙、陷阱和釘刺。遊戲的目標是保持您的箭頭在路徑上，並盡可能地走得更遠。遊戲包含經典模式（帶有關卡）、賽跑模式（2-3-4人）您可以進行多場賽跑，以及無限模式讓您可以自我挑戰！幾何波動，激情不斷的地方，邀請您挑戰……",
      "instructions": "點擊以「左鍵點擊」或「上箭頭」並按住以升空。\n釋放按鈕以俯衝。\n在2人、3人、4人遊戲模式中，其他玩家使用「上箭頭」、「H」和「L」來控制。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2人遊戲",
        "3人遊戲",
        "短暫",
        "幾何",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "幾何韻律",
      "description": "幾何節奏是一款反應基礎的街機遊戲，遊戲中你要避開一波又一波的障礙、陷阱和釘子。遊戲目標是保持你的箭頭在路徑上，並盡可能地走得更遠。遊戲包含經典模式（含關卡）、賽跑模式（2-3-4人）讓你可以進行多場賽跑，以及無盡模式讓你可以挑戰自我！幾何節奏，刺激無窮盡，邀請你挑戰……",
      "instructions": "點擊「MOUSE LEFT-CLICK」或「上箭頭」並按住以上升飛翔。\n釋放按鈕以向下潛水。\n在2,3,4人遊戲模式中，其他玩家可使用「上箭頭」、「H」及「L」操控。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "二人遊戲",
        "三人遊戲",
        "短暫衝刺",
        "幾何學",
        "奔跑"
      ]
    },
    "ja": {
      "title": "幾何ビブズ",
      "description": "ジオメトリ・ビブズは、連続して現れる障害物、罠、トゲを避けながらの反応型アーケードゲームです。ゲームのゴールは、矢印をルートに保ち、できるだけ遠くまで進むことです。ゲームには、レベルがあるクラシックモード、2-3-4人でのレースができるレースモード、そして自己採点ができる無限モードが含まれています！終わりなき興奮が満載のジオメトリ・ビブズが、あなたに挑戦を呼びかけます！",
      "instructions": "クリックして「MOUSE LEFT-CLICK」または「UP ARROW」を押し、飛び上がるために長押ししてください。\nボタンを離すと、潜り下がります。\n2人、3人、4人用ゲームモードでは、他のプレイヤーは「UP ARROW」、「H」、および「L」で操作されます。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2人用",
        "3人用",
        "ダッシュ",
        "幾何学",
        "走る"
      ]
    },
    "ko": {
      "title": "지오메트리 비브스",
      "description": "지오메트리 빙스는 반응형 아케이드 게임으로, 넘치는 장애물, 트랩, 날카로운 돌기를 피해야 합니다. 게임의 목표는 아로를 최대한 멀리 이동시키는 것입니다. 이 게임에는 레벨이 포함된 클래식 모드, 2-3-4인용 레이스 모드(여러 차례 레이스 가능), 무한 모드(자신을 시험할 수 있는 모드)가 있습니다! 즐거움이 끝나지 않는 지오메트리 빙스에서는 도전에 초대합니다...",
      "instructions": "마우스 왼쪽 클릭 또는 \"위쪽 방향키\"를 클릭하여 날아오르세요. 버튼을 놓으면 내려가세요. 2, 3, 4 인원 게임 모드에서는 다른 플레이어는 \"위쪽 방향키\", \"H\" 및 \"L\"로 제어됩니다.",
      "genres": [
        "모험"
      ],
      "tags": [
        "2인",
        "3인",
        "타이밍",
        "기하학",
        "달리기"
      ]
    },
    "fr": {
      "title": "Vibes de Géométrie",
      "description": "Geometry Vibes est un jeu d'arcade basé sur la réaction où vous évitez les obstacles, les pièges et les épingles qui vous tombent en vagues. Votre objectif dans le jeu est de garder votre flèche sur le chemin et de la faire avancer le plus loin possible. Le jeu inclut un mode classique avec des niveaux, un mode course (2-3-4 joueurs) où vous pouvez participer à plusieurs courses, et un mode infini où vous pouvez tester vos capacités ! Geometry Vibes, où l'excitation ne cesse jamais, vous invite à défier...",
      "instructions": "Cliquez sur \"Clique gauche de la souris\" ou \"Flèche haute\" et maintenez pour monter.\nRelâchez le bouton pour plonger.\nDans les modes de jeu à 2, 3, 4 joueurs, les autres joueurs sont contrôlés avec \"Flèche haute\", \"H\" et \"L\".",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2 joueurs",
        "3 joueurs",
        "dash",
        "géométrie",
        "course"
      ]
    }
  }
};
